const API = {
    // Component/auth/API.js
    
    // leetcodeAPI: 'https://leetcode.com/graphql',
    leetcodeAPI: 'https://alfa-leetcode-api.onrender.com/userProfile/',
    gfgAPI: 'https://geeksforgeeksapi.vercel.app/api/gfg?username=',
    CodeforcesAPI: "https://codeforces.com/api/user.info?handles=",
    CodeforcesStatusAPI: "https://codeforces.com/api/user.status?handle=",

    CodeChef: '',
    HackerRank: '',
    codingNinjasAPI: '',
    
};

export default API;